module.exports = __webpack_public_path__ + "balboa-condensed.otf";